import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';
import './LoadingSpinner.scss';

interface FullPageLoadingSpinnerProps {
  message?: string;
}

export const FullPageLoadingSpinner: React.FC<FullPageLoadingSpinnerProps> = ({ 
  message = 'Loading application...' 
}) => {
  return (
    <div className="loading-spinner-fullpage">
      <LoadingSpinner message={message} />
    </div>
  );
};